module.exports = __webpack_public_path__ + "static/media/sv_si_egrove_logo_navypng.b12ba43a.png";